import {BaseElement, OSkinableInit} from "/@back@/commons/basis.js";
import {IItemUiEnv, installSrcViewFileDrop} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IView} from "/@lib@/commons/views.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {JWspUriChangeMsg, WSP} from "/@lib@/wsp/wsp.js";
import {SRC} from "/@lib@/wsp/src.js";
import {IAction} from "/@lib@/commons/actions.js";
import {IShortDescCtx} from "/@lib@/wsp/item.js";
import {BarActions, OBarActionsInit} from "/@back@/commons/widgets/bars.js";

/**
 * View du contenu textuel d'un item (RO)
 *
 * Config attributes:
 */
export interface OItemTxtInit extends OSkinableInit {
	reg?: IReg<IItemUiEnv>
	transform?: string
}

export interface ItemTxt extends BaseElement {
	initialize(init: OItemTxtInit): this
}

export class ItemTxt extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;

	private _textareaElt: HTMLTextAreaElement;

	_initialize(init: OItemTxtInit) {
		this.reg = this.findReg(init);
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		this.reg.installSkin('scroll/large', sr);

		installSrcViewFileDrop(this.reg, this);
		const {env} = this.reg;

		this._textareaElt = <textarea readonly/> as HTMLTextAreaElement;
		const ctx = this.reg.env.srcView;
		const actions = this.reg.mergeLists<IAction<IShortDescCtx>>("actions:wsp:itemTxt", "actions:wsp:binaryStream").filter((a) => a.isInstantiable(ctx));
		if (actions.length > 0) sr.appendChild(
			<BarActions î={{actions, actionContext: ctx, reg: this.reg} as OBarActionsInit<IShortDescCtx>}/>
		);
		sr.appendChild(this._textareaElt);

		// Listener sur les changements de la ressource
		env.place.eventsMgr.on("wspUriChange", (msg: JWspUriChangeMsg) => {
			if (SRC.srcRef(env.longDesc) === SRC.srcRef(msg)) {
				this.refreshContent(env, init.transform);
			}
		});

		this.refreshContent(this.reg.env, init.transform);
	}

	async refreshContent(env: IItemUiEnv, transform: string) {
		this._textareaElt.value = await WSP.fetchStreamText(env.wsp, this, env.itemType.getMainStreamSrcUri(env.longDesc), transform);
	}
}

REG.reg.registerSkin("wsp-item-txt", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
	  flex: 1;
	  flex-direction: column;
	  padding: 1px;
  }

  textarea {
	  flex: 1;
	  border: none;
	  resize: none;
	  outline: none;
	  background-color: var(--bgcolor);
	  color: var(--color);
  }
`);


customElements.define("wsp-item-txt", ItemTxt);
